import { motion } from 'framer-motion';

const Terms = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8'
    >
      <h1 className='text-3xl font-bold text-primary-light mb-6'>Terms and Conditions</h1>

      <div className='bg-white rounded-lg shadow-md p-6'>
        <section className='mb-8'>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Acceptance of Terms</h2>
          <p className='text-gray-600 leading-relaxed'>
            By accessing and using Natco Pharmacy's services, you acknowledge that you have read,
            understood, and agree to be bound by these Terms and Conditions. If you do not agree
            with these terms, please do not use our services.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Use of Service</h2>
          <p className='text-gray-600 leading-relaxed mb-4'>
            Our service is provided for informational purposes only. While we strive to maintain
            accurate and up-to-date information, we cannot guarantee the accuracy of all
            verification results.
          </p>
          <ul className='list-disc list-inside text-gray-600 leading-relaxed'>
            <li>You must use the service as intended</li>
            <li>Do not attempt to bypass security measures</li>
            <li>Report any suspicious activity</li>
            <li>Do not submit false information</li>
          </ul>
        </section>

        <section className='mb-8'>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Limitations of Liability</h2>
          <p className='text-gray-600 leading-relaxed'>
            Natco Pharmacy and its affiliates shall not be liable for any direct, indirect,
            incidental, special, or consequential damages resulting from the use or inability to use
            our services. This includes but is not limited to damages for loss of profits, goodwill,
            data, or other intangible losses.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Modifications</h2>
          <p className='text-gray-600 leading-relaxed'>
            We reserve the right to modify these terms at any time. Continued use of our service
            after any modifications indicates your acceptance of the updated terms. It is your
            responsibility to review these terms periodically.
          </p>
        </section>

        <section>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Contact Information</h2>
          <p className='text-gray-600 leading-relaxed'>
            For any questions regarding these terms, please contact us at:
          </p>
          <ul className='list-none text-gray-600 leading-relaxed mt-2'>
            <li>Email: legal@Natco Pharmacy.com</li>
            <li>Phone: +1 (555) 123-4567</li>
            <li>Address: 123 Medical Plaza, Healthcare City</li>
          </ul>
        </section>
      </div>
    </motion.div>
  );
};

export default Terms;
